import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Toolbar } from "../../Toolbar";

export const LiveIndicator = () => (
  <Toolbar.Indicator
    className="pl-3 pr-2"
    label={t("live_streams.room.live")}
    danger
  >
    <div className="text-[#e02f2f]">
      <Icon type="live-indicator" size={24} className="h-6 w-6" />
    </div>
  </Toolbar.Indicator>
);
